@if (isSuccess) {
  <div class="contactForm contactForm--success">
    <p class="text-center font-medium">{{ 'contactForm.success' | transloco }}</p>
  </div>
} @else {
  <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contactForm" novalidate>
    <p-floatlabel variant="in" class="contactForm__input">
      <p-select
        formControlName="type"
        inputId="in_label"
        [options]="optionsContact()"
        optionLabel="title"
        styleClass="w-full"
        fluid
      />
      <label for="in_label">{{ 'contactForm.typeLabel' | transloco }}</label>
    </p-floatlabel>

    <p-floatlabel variant="in" class="contactForm__input">
      <input pInputText id="name" formControlName="name" autocomplete="name" fluid />
      <label for="name">{{ 'contactForm.nameLabel' | transloco }}</label>
    </p-floatlabel>

    <p-floatlabel variant="in" class="contactForm__input">
      <input
        pInputText
        id="email"
        formControlName="email"
        type="email"
        autocomplete="email"
        fluid
      />
      <label for="email">{{ 'contactForm.emailLabel' | transloco }}</label>
    </p-floatlabel>

    <p-floatlabel variant="in" class="contactForm__input">
      <textarea
        pTextarea
        id="message"
        formControlName="message"
        rows="5"
        cols="30"
        style="resize: none"
        class="h-full"
        fluid
      ></textarea>
      <label for="message">{{ 'contactForm.messageLabel' | transloco }}</label>
    </p-floatlabel>

    @if (isError) {
      <small class="text-red-500">{{ 'contactForm.error' | transloco }}</small>
    }

    <button
      class="contactForm__button"
      pButton
      type="submit"
      severity="secondary"
      size="large"
      [loading]="isLoading"
      [disabled]="isLoading"
    >
      {{ 'contactForm.submit' | transloco }}
    </button>
  </form>
}
